// Zastępczy pojazd dla wiszących referencji.
//
// Trasa trzyma pojazd jako referencję, a usunięcie pojazdu (/deleteVehicle) NIE rusza
// tras, które go używają. Podstawienie z mapy — `vehicles[route.vehicle.id]` — dawało
// wtedy `undefined`, a każdy odczyt `vehicle.attribs.licensePlate.value` wywracał cały
// widok. Jeden brakujący pojazd zabierał ze sobą listę wszystkich tras.
//
// Zamiast łatać dwieście odczytów, oddajemy obiekt o TYM SAMYM KSZTAŁCIE co prawdziwy
// pojazd. Wszystko, co dotąd działało, działa dalej; różnica jest tylko taka, że na
// ekranie widać „pojazd usunięty" zamiast pustego miejsca albo białego ekranu.
export function deletedVehicle(id) {
  return {
    id: id || null,
    active: false,
    // Po tej fladze poznaje się zastępczy wpis — przydaje się, gdy widok chce go
    // pokazać inaczej niż zwykły pojazd.
    deleted: true,
    available: false,
    brand: 'Pojazd',
    model: 'usunięty z systemu',
    img: '',
    ref: null,
    attribs: {
      dimensions: { unit: 'cm', height: 0, width: 0, length: 0 },
      weight: { unit: 'kg', amount: 0 },
      licensePlate: { name: 'Tablice rejestracyjne', value: '—' },
      payloadCapacity: { name: 'Pojemność transportowa', value: 0 },
    },
  };
}

// Podstawienie pojazdu z mapy w jednym miejscu — żeby żaden widok nie musiał pamiętać
// o przypadku brakującego wpisu.
export function vehicleOrPlaceholder(mapa, id) {
  return (id && mapa && mapa[id]) || deletedVehicle(id);
}
